import _ from 'lodash'
import logger from '@adc/logger'
import {
  ASSET_SELECTED,
  MAP_ASSET_SELECTED,
  TRIGGERED_MOUSE_EVENT_FLAG,
  ADGLARE_CONTENT_FETCHED,
} from '../constants/actionTypes'
import { fetchAdglareContent } from '../providers/adglare'
export const UPDATE_SELECTED_ID_TIMEOUT = 50

const updateSelectedIdAction = _.debounce((dispatch, getState, id) => {
  // important - only update selected id if necessary
  if (getState()?.assets?.selectedId !== id) {
    dispatch({
      type: ASSET_SELECTED,
      value: id,
    })
  }
}, UPDATE_SELECTED_ID_TIMEOUT)

// update the selected asset
export const updateSelectedId = id => {
  return (dispatch, getState) => updateSelectedIdAction(dispatch, getState, id)
}

const updateMapMarkerSelectedIdAction = _.debounce((dispatch, getState, id) => {
  if (getState()?.assets?.mapSelectedId !== id) {
    dispatch({
      type: MAP_ASSET_SELECTED,
      value: id,
    })
  }
}, UPDATE_SELECTED_ID_TIMEOUT)

// Update the selected MAP asset
// Unlike the selectedId above, which is used to handle property card hover,
// and notify wich popup card to display, we need a separate one for the reverse
// otherwise, hovering over the card would trigger unintended scrolling
export const updateMapMarkerSelectedId = id => {
  return (dispatch, getState) =>
    updateMapMarkerSelectedIdAction(dispatch, getState, id)
}

// We use this flag as a way to control whether certain mouse events were triggered
// programatically or not.
export const setTriggeredMouseEventFlag = value => ({
  type: TRIGGERED_MOUSE_EVENT_FLAG,
  value,
})

export const fetchAdContent = (dispatch, url) => {
  fetchAdglareContent(url)
    .then(response => response.json())
    .then(data => {
      // Assuming data.response.campaigns is an array of campaigns
      if (data.response?.campaigns?.length > 0) {
        // Get the HTML code from the first campaign
        const creativeData = data.response.campaigns[0].creative_data
        const htmlCode = creativeData.code
        const clickTrackingUrl = creativeData.click_url

        // Create a DOM parser
        const parser = new DOMParser()
        const doc = parser.parseFromString(htmlCode, 'text/html')

        // Find the ag (adglare) button by id
        const element = doc.getElementById('ag-action-button-id')

        if (element) {
          // Modify the onclick attribute
          element.setAttribute(
            'onclick',
            `navigator.sendBeacon('${clickTrackingUrl}')`
          )
        }

        // Convert the modified HTML back to a string
        const modifiedHTML = doc.documentElement.outerHTML

        dispatch({
          type: ADGLARE_CONTENT_FETCHED,
          value: modifiedHTML,
        })
      } else {
        logger.warn('No campaigns found in the JSON response.')
      }
    })
    .catch(error => {
      logger.warn('Error fetching adglare content data:', error)
      dispatch({
        type: ADGLARE_CONTENT_FETCHED,
        value: null,
      })
    })
}
